import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'fllt-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent {
    @Output() start = new EventEmitter()

    startTest() {
        this.start.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.ts